<template>
  <div class="deposit_selection" v-if="false">
    <div class="flex entry tobox">
      <div class="mr-2">
        <radio-input v-model="deposit_off" />
      </div>
      <p>
        <span class="text_size-medium">Pay full amount</span>
      </p>
    </div>
    <div class="flex entry topbox">
      <div class="mr-2">
        <radio-input v-model="deposit_on" />
      </div>
      <p>
        <span class="text_size-medium" v-if="client.DepositPercent > 0"
          >Pay {{ Math.round(client.DepositPercent) }}% deposit</span
        >
        <span class="text_size-medium" v-if="client.DepositPercent == 0"
          >Pay later</span
        ><br />
        <br />
        <small v-if="client.DepositPercent != 0" class="text_size-small"
          >This option is available for orders of
          <currency :value="client.DepositMinOrderTotal" /> or more. Balance due
          upon arrival.</small
        >
        <small v-else class="space"
          >Card on file required for booking. Cancellation policies apply. Full
          payment due at a later time.</small
        >
      </p>
    </div>

    <div v-show="err != false">{{ err }}</div>
    <!-- <pre>
Order Deposits = {{ order.Deposits }}
Deposit On = {{ deposit_on }}
Deposit Off = {{ deposit_off }}
    </pre> -->
    <div class="deposit_loader" v-if="loading"><loader /></div>
  </div>

  <div v-else class="deposit-selection">
    <div class="deposit-opt">
      <radio-input v-model="deposit_off" />
      <span class="text_size-medium">Pay full amount</span>
      <div class="deposit_loader" v-if="loading && deposit_off"><loader /></div>
    </div>
    <div class="deposit-opt" style="margin-top: 15px">
      <radio-input v-model="deposit_on" />
      <span class="text_size-medium" v-if="client.DepositPercent > 0"
        >Pay {{ Math.round(client.DepositPercent) }}% deposit</span
      >
      <span class="text_size-medium" v-if="client.DepositPercent == 0"
        >Pay later</span
      >
      <div class="deposit_loader" v-if="loading && deposit_on"><loader /></div>
    </div>
    <p
      v-if="client.DepositPercent != 0"
      class="text_size-medium-small deposit-text"
      style="font-weight: 400; color: #6a6a6a;"
    >
      This option is available for orders of
      <currency :value="client.DepositMinOrderTotal" /> or more. Balance due
      upon arrival.
    </p>
    <p
      v-else
      class="text_size-medium-small deposit-text"
      style="font-weight: 400"
    >
      Card on file required for booking. Cancellation policies apply. Full
      payment due at a later time.
    </p>
    <div v-show="err != false">{{ err }}</div>
    <!-- <div class="deposit_loader" v-if="loading"><loader /></div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import Loader from "../components/Loader.vue";
import RadioInput from "./RadioInput.vue";

export default {
  name: "Deposit",
  components: { Loader, RadioInput },
  computed: {
    ...mapState(["order", "client"]),
  },
  data() {
    //       console.log("rendering data",this.$store.state.order)
    return {
      deposit_on: this.$store.state.order.Deposits > 0,
      deposit_off: this.$store.state.order.Deposits == 0,
      err: false,
      loading: false,
    };
  },
  methods: {
    saveDeposit(type) {
      var url =
        this.$store.state.serverPath +
        "/" +
        type +
        "?ClientLocationKey=" +
        this.$route.params.client +
        "&OrderKey=" +
        this.$store.state.order.OrderKey;
      // eslint-disable-next-line no-undef
      $.ajax({
        type: "GET",
        data: "json",
        url: url,
        cache: false,
        success: (json) => {
          this.loading = false;
          if (!json) {
            console.warn("Deposit came back empty");
          } else if (typeof json.Order == "undefined") {
            console.warn(json.Message);
            this.err = json.Message;
          } else {
            this.$store.commit("updateOrder", json.Order);
          }
        }, //success
        error: (msg) => {
          this.loading = false;
          console.warn(msg);
        },

        done: function() {
          this.loading = false;
        },
      }); // ajax
    },
  },
  watch: {
    "order.Deposits": {
      handler: function(val) {
        this.deposit_on = val > 0;
        this.deposit_off = val == 0;
      },
    },
    deposit_on: {
      handler: function(val) {
        if (val) {
          this.loading = true;
          this.saveDeposit("EnableDeposit");
        }
        this.deposit_off = !val;
      },
    },
    deposit_off: {
      handler: function(val) {
        if (val) {
          this.loading = true;
          this.saveDeposit("DisableDeposit");
        }
        this.deposit_on = !val;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.deposit-selection {
  padding: 0 var(--inner-padding);
  display: grid;
  position: relative;

  // > * {
  //   outline: 1px solid red;
  // }
}

.deposit-text {
  margin-top: 0;
  margin-left: 35px;
}

.deposit-opt {
  position: relative;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  // max-height: fit-content;
  > span:nth-child(2) {
    padding-left: 12px;
  }

  // outline: 1px solid red;
}

.deposit_selection {
  border-bottom: 1px solid #d6dce6;
  position: relative;
  clear: left;
}
.deposit_selection .entry p {
  width: 100%;
}
.deposit_selection .entry {
  font-size: 14pt;
  padding: 10px 0px;
  color: inherit;
  text-decoration: none;
  margin: 10px 0;
  font-weight: 500;
  font-family: "AvenirMedium", "Avenir Next", "proxima_nova_rgregular",
    "Proxima Nova", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI",
    HelveticaNeue-Light, "Helvetica Neue Light", "Helvetica Neue", Helvetica,
    MuseoSans500, "Lucida Grande", Lucida, Verdana, sans-serif;
}
.deposit_loader {
  // position: absolute;
  // right: 0px;
  // top: 0px;
  padding-right: 8px;
  transform: scale(0.75);
  -webkit-transform: scale(.75);
}
small.space {
  color: grey;
  font-size: 10pt;
  font-family: "AvenirBook";
}

</style>
